import type { AccumulationChart, IAccLoadedEventArgs } from '@syncfusion/ej2-charts';

interface ExerciseDataItem {
    Exercise: string;
    Hours: number;
}

export async function exercisePieChart(appendTo: string, data: ExerciseDataItem[]) {

    await import('./loadSyncfusion');

    const { AccumulationChart, PieSeries, AccumulationTooltip, AccumulationLegend, AccumulationDataLabel } = await import('@syncfusion/ej2-charts');

    AccumulationChart.Inject(PieSeries, AccumulationTooltip, AccumulationLegend, AccumulationDataLabel);

    const commonFont = { color: '#fff', fontFamily: 'Helvetica' };

    const chart: AccumulationChart = new AccumulationChart({
        series: [
            {
                dataSource: data,
                xName: 'Exercise',
                yName: 'Hours',
                dataLabel: {
                    visible: true,
                    name: 'Exercise',
                    position: 'Outside',
                    connectorStyle: { length: '10%' },
                    font: commonFont
                },
                radius: '70%',
                palettes: ['#FFD700', '#FF4500', '#00BFFF', '#32CD32', '#FF69B4', '#8A2BE2']
            }
        ],
        legendSettings: {
            visible: true,
            textStyle: commonFont
        },
        tooltip: {
            enable: true,
            format: '${point.x}: ${point.y} hours'
        },
        background: '#3A3A3A',
        width: '100%',
        height: '100%',
        loaded: (args: IAccLoadedEventArgs) => {
            const chart = args.accumulation;
            chart.theme = 'Material';
        }
    });

    chart.appendTo(appendTo);
}
